import {Link, useLocation} from 'react-router-dom';

interface NavItem {
  title: string;
  url: string;
}

interface PanelHeaderProps {
  title?: string;
  navItems?: NavItem[];
  showProfile?: boolean;
}

// Default navigation items
const DEFAULT_NAV_ITEMS: NavItem[] = [
  { title: 'Playlists', url: '/p/cp/playlists' },
  { title: 'Library', url: '/p/cp/tracks' },
];

export const PanelHeader = (props: PanelHeaderProps) => {
  const location = useLocation();
  const title = props.title || 'Beatless';
  const navItems = props.navItems || DEFAULT_NAV_ITEMS;
  const showProfile = props.showProfile !== false;

  return (
    <header style={{
      backgroundColor: 'var(--headerBg)',
      padding: '16px 24px',
    }}>
      <div style={{
        maxWidth: '983px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {/* Left: Logo + Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Logo icon */}
          <div style={{
            width: '32px',
            height: '32px',
            backgroundColor: 'var(--primaryColor)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
              <path d="M8 0L16 6V14L8 20L0 14V6L8 0Z" fill="white"/>
            </svg>
          </div>
          <span style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            color: '#101727',
            letterSpacing: '-0.3px',
          }}>
            {title}
          </span>
        </div>

        {/* Center: Navigation */}
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          {navItems.map((item) => {
            const isActive = location.pathname === item.url ||
              (item.url.includes('/tracks') && location.pathname.startsWith(item.url));

            return (
              <Link
                key={item.url}
                to={item.url}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 16px',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  backgroundColor: isActive ? 'var(--primaryColor)' : 'transparent',
                  transition: 'background-color 0.15s',
                }}
              >
                <span style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '16px',
                  fontWeight: 400,
                  color: isActive ? '#ffffff' : '#354152',
                  letterSpacing: '-0.3px',
                  lineHeight: '24px',
                }}>
                  {item.title}
                </span>
              </Link>
            );
          })}
        </nav>

        {/* Right: Profile button */}
        {showProfile && (
          <Link
            to="/p/cp/profile"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              textDecoration: 'none',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="6" r="4" stroke="#354152" strokeWidth="1.5"/>
              <path d="M2 18C2 14 5.5 12 10 12C14.5 12 18 14 18 18" stroke="#354152" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: 400,
              color: '#354152',
              letterSpacing: '-0.3px',
            }}>
              Profile
            </span>
          </Link>
        )}
      </div>
    </header>
  );
};
